import React, { useState, createContext, useEffect, useContext} from "react"
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import * as jsondiffpatch from 'jsondiffpatch';
import PopupNotifContext from "./PopupNotifContext"


import APIS from "../utils/APIS"
import listFormats from "../utils/listFormats"

const SuperAdminContext = createContext()

const SuperAdminProvider = ({ children }) => {
  const navigate = useNavigate();

  const { addPopupNotif } = useContext(PopupNotifContext)

  const [firstLoad, setFirstLoad] = useState(false)

  const [playerHasChanged, setPlayerHasChanged] = useState(false)

  const [overlayForSave, setOverlayForSave] = useState(false)

  const [groupes, setGroupes] = useState([])
  const [contents, setContents] = useState([])
  const [adminClients, setAdminClients] = useState([])
  const [ecoles, setEcoles] = useState([])

  const [content, setContent] = useState(null)
  const [adminPlayerIndexes, setAdminPlayerIndexes] = useState({ chapitre: 0, partie: 0, sequence: 0 })


  useEffect(() => {
    if (firstLoad === false) {
      updateSuperAdminContext()
      setFirstLoad(true)
    }
  }, [firstLoad])

  const updateSuperAdminContext = () => {
    console.log("updateSuperAdminContext")
    updateAdminGroupes()
    updateAdminContents()
    updateAdminAdminClients()
    updateAdminEcoles()
  }

  const updateAdminGroupes = (withArchived) => {
    let vals = {}
    if (withArchived === true) {
      vals.archived = true;
    }
    APIS.getSuperAdminGroupes(vals).then((results) => {
      //console.log(results)
      setGroupes(results)
    })
  }

  const updateAdminContents = (withArchived) => {
    let vals = {}
    if (withArchived === true) {
      vals.archived = true;
    }
    APIS.getSuperAdminContents(vals).then((results) => {
      if (results?.formations) {
        //console.log(result.formations)
        setContents(results.formations)
      }
    })
  }

  const updateAdminAdminClients = () => {
    APIS.getSuperAdminAdminClients().then((results) => {
      //console.log(results)
      setAdminClients(results)
    })
  }

  const updateAdminEcoles = () => {
    APIS.getSuperAdminEcoles().then((results) => {
      //console.log(results)
      setEcoles(results)
    })
  }

  const sequencesDataRefacto = (seq) => {
    if (seq.button && seq.button !== null) {
      try {
        seq.button = JSON.stringify(seq.button)
      } catch(e) { }
    }
    if (seq.buttonStart && seq.buttonStart !== null) {
      try {
        seq.buttonStart = JSON.stringify(seq.buttonStart)
      } catch(e) { }
    }
    if (seq.buttonNext && seq.buttonNext !== null) {
      try {
        seq.buttonNext = JSON.stringify(seq.buttonNext)
      } catch(e) { }
    }
    if (seq.image && seq.image !== null) {
      try {
        seq.image = JSON.stringify(seq.image)
      } catch(e) { }
    }
    if (seq.responses && seq.responses !== null) {
      try {
        seq.responses = JSON.stringify(seq.responses)
      } catch(e) {
        seq.responses = seq.responses
      }
    }
    if (seq.answers && seq.answers !== null) {
      try {
        seq.answers = JSON.stringify(seq.answers)
      } catch(e) { }
    }
    if (seq.total && seq.total !== null) {
      try {
        seq.total = JSON.stringify(seq.total)
      } catch(e) { }
    }
    if (seq.categorie && seq.categorie !== null) {
      try {
        seq.categorie = JSON.stringify(seq.categorie)
      } catch(e) {
        seq.categorie = seq.categorie
      }
    }

    return seq
  }

  const deltaPathToElementRemove = (formation, path) => {
    let pathArr = path.substring(1).split('/')
    let element = {...formation};

    for (let i=0; i<pathArr.length; i++) {
      element = element[pathArr[i]]
    }

    return ({el : element, type : pathArr[pathArr.length-2]})
  }

  const deltaPathToElementAdd = (formation, path) => {
    let pathArr = path.substring(1).split('/')
    let element = {...formation};

    for (let i=0; i<pathArr.length-2; i++) {
      element = element[pathArr[i]]
    }

    return ({el : element, type : pathArr[pathArr.length-2], position : pathArr[pathArr.length-1]})
  }

  const deltaPathToElementReplace = (formation, path) => {
    let pathArr = path.substring(1).split('/')
    let keyToChange = pathArr[pathArr.length - 1]
    let element = {...formation};

    for (let i=0; i<pathArr.length-1; i++) {
      element = element[pathArr[i]]
    }

    return ({el : element, type : pathArr[pathArr.length-3] || 'content', key : keyToChange})
  }

  const saveAdminContent = async (newContent, newIndexes) => {
    setOverlayForSave(true)

    let actFormation = JSON.parse(JSON.stringify(newContent))
    let contentID = actFormation.id;
    let compareForSave = JSON.parse(sessionStorage.getItem('saveFormationAdmin'))

    //on verifie encore une fois les position de chaque element
    actFormation.feedbackFin = JSON.stringify(actFormation.feedbackFin) //pour le feedback Fin
    actFormation.chapitre.forEach((chap, indexChap) => {
      chap.position = indexChap;
      chap.partie.forEach((part, indexPart) => {
        part.position = indexPart;
        part.sequence.forEach((seq, indexSeq) => {
          seq.position = indexSeq;
          seq = sequencesDataRefacto(seq)
        })
      })
    })

    //on verifie encore une fois les position de chaque element
    compareForSave.feedbackFin = JSON.stringify(compareForSave.feedbackFin) //pour le FeedbackFin
    compareForSave.chapitre.forEach((chap, indexChap) => {
      chap.position = indexChap;
      chap.partie.forEach((part, indexPart) => {
        part.position = indexPart;
        part.sequence.forEach((seq, indexSeq) => {
          seq.position = indexSeq;
          seq = sequencesDataRefacto(seq)
        })
      })
    })

    console.log(JSON.stringify(actFormation))
    console.log(JSON.stringify(compareForSave))

    var diffpatcher = jsondiffpatch.create({
      cloneDiffValues: true,
      propertyFilter: function(name, context) {
        if (name !== 'color') {
          return name;
        }
      },
      objectHash: function(obj, index) {
        return obj.id || '$$index:' + index;
      },
      arrays: {
          // default true, detect items moved inside the array (otherwise they will be registered as remove+add)
          detectMove: true,
          // default false, the value of items moved is not included in deltas
          includeValueOnMove: false,
      },
      textDiff: {
          minLength: 99999999999999,
      },
    });
    let delta = diffpatcher.diff(compareForSave, actFormation);
    if (delta) {
      let deltaFormat = jsondiffpatch.formatters.jsonpatch.format(delta)
      let changesArray = []
      let secureDeletesArray = []
      //console.log(deltaFormat)
      deltaFormat.forEach((change) => {
        if (change.op === "replace") {
          if (change.path === "/feedbackFin") {
            let feedbackFin = JSON.parse(change.value)
            changesArray.push(async function() {
              return await APIS.editFormationElement(
                'content',
                {
                  id : contentID,
                  feedbackTitle : feedbackFin.titre,
                  feedbackFormID : feedbackFin.formulaire,
                  feedbackSeuil : feedbackFin.seuil,
                  feedbackBtnType : feedbackFin.button.type,
                  feedbackBtnText : feedbackFin.button.text,
                  feedbackSucces : feedbackFin.succes,
                  feedbackFail : feedbackFin.fail
                }
              )
            })
          } else {
            let infosUpdate = deltaPathToElementReplace(actFormation, change.path)
            if (infosUpdate.type) {
              console.log("change "+infosUpdate.type+" with id "+infosUpdate.el.id+", key "+infosUpdate.key+" to "+change.value)
              changesArray.push(async function() {
                return await APIS.editFormationElement(
                  infosUpdate.type,
                  {
                    id : infosUpdate.el.id,
                    [infosUpdate.key] : change.value
                  }
                )
              })
            }
          }
        } if (change.op === "add") {
          let infosAdd = deltaPathToElementAdd(actFormation, change.path)
          change.value.position = infosAdd.position
          delete change.value.id;
          delete change.value.partieID;
          delete change.value.chapterID;
          if (infosAdd.type) {
            console.log("add "+infosAdd.type+" to element with id "+infosAdd.el.id+", with value "+JSON.stringify(change.value))
            if (infosAdd.type === "sequence" || infosAdd.type === "partie" || infosAdd.type === "chapitre") {
              changesArray.push(async function() {
                return await APIS.addFormationElement(
                  infosAdd.type,
                  infosAdd.el.id,
                  change.value
                )
              })
            }
          }
        } if (change.op === "remove") {
          let infosRemove = deltaPathToElementRemove(compareForSave, change.path)
          if (infosRemove.type) {
            console.log("remove "+infosRemove.type+" with id "+infosRemove.el.id)
            if (infosRemove.type === "sequence" || infosRemove.type === "partie" || infosRemove.type === "chapitre") {
              secureDeletesArray.push({
                type : infosRemove.type,
                id : infosRemove.el.id
              })
              changesArray.push(async function() {
                return await APIS.removeFormationElement(
                  infosRemove.type,
                  infosRemove.el.id
                )
              })
            }
          }
        }
      })

      if (changesArray.length > 0) {
        let textConfirm = "Confirmez-vous la suppression des éléments suivants ?\n"
        if (secureDeletesArray.length > 0) {
          for (let i=0; i<secureDeletesArray.length;i++) {
            textConfirm += "- " + secureDeletesArray[i].type + " avec l'ID " + secureDeletesArray[i].id + "\n";
          }
        }
        if (secureDeletesArray.length === 0 || window.confirm(textConfirm) == true) {
          const results = await Promise.all(changesArray.map(f => f()));
          let vals = {}
          if (actFormation.archived === "true") {
            vals.archived = true;
          }
          updateAdminContents()
          let find = await APIS.getContentByIdForAdmin({id : newContent?.id})
          if (find) {
            if (newIndexes) {
              setAdminPlayerIndexes(newIndexes)
            }
            setContent(find)
            sessionStorage.setItem('saveFormationAdmin', JSON.stringify(find));
            setPlayerHasChanged(false)
            setOverlayForSave(false)
          }
        } else {
          document.location.reload()
        }

      }

    } else {
      console.log("no change")
      setOverlayForSave(false)
      setPlayerHasChanged(false)
    }


  }

  const checkAllPositions = (formation) => {
    formation.chapitre.forEach((chap, indexChap) => {
      chap.position = indexChap;
      chap.partie.forEach((part, indexPart) => {
        part.position = indexPart;
        part.sequence.forEach((seq, indexSeq) => {
          seq.position = indexSeq;
        })
      })
    })
    return formation
  }

  const defautPartie = () => {
    return {
      //isDone: false,
      title: 'Ecrire le titre ici',
      sequence: [listFormats("Titre")],
    }
  }
  const defautChapitre = () => {
    return {
      time: 0,
      //isDone: false,
      title: 'Ecrire ici',
      partie: [defautPartie()],
    }
  }

  const addChapitre = (iChap, newChapIndex, newChapitre) => {
    let newFormation = JSON.parse(JSON.stringify(content))
    newFormation?.chapitre?.splice(iChap, 0, newChapitre ? newChapitre : defautChapitre() )

    let newIndexes = {chapitre : newChapIndex, partie : 0, sequence : 0}

    //autosave
    saveAdminContent(newFormation, newIndexes)
  }

  const deleteChapitre = (iChap) => {
    let newFormation = JSON.parse(JSON.stringify(content))
    newFormation?.chapitre?.splice(iChap, 1)

    newFormation = checkAllPositions(newFormation)

    //si il ne reste plus de chapitre, on doit en rajouter un
    if (newFormation?.chapitre?.length === 0) {
      newFormation?.chapitre?.splice(0, 0, defautChapitre() )
    }

    setContent(newFormation)

    //on regarde pour les indexes
    if (iChap === adminPlayerIndexes?.chapitre) {
      //on est sur le chapitre supprimé
      var iChapNew = iChap == 0 ? 0 : iChap - 1
      setAdminPlayerIndexes({chapitre : iChapNew, partie : 0, sequence : 0})
    } else if (adminPlayerIndexes?.chapitre > iChap) {
      setAdminPlayerIndexes({chapitre : adminPlayerIndexes?.chapitre - 1, partie : adminPlayerIndexes?.partie, sequence : adminPlayerIndexes?.sequence})
    }

    //autosave
    saveAdminContent(newFormation)
  }

  const duplicateChapitre = (iChap) => {
    var newChap = JSON.parse(JSON.stringify(content?.chapitre[iChap]))

    addChapitre(iChap, iChap + 1, newChap)
  }

  const addPartie = (indexes, newPartie) => {
    let newFormation = JSON.parse(JSON.stringify(content))
    newFormation?.chapitre[indexes?.iChap]?.partie?.splice(indexes?.iPart, 0, newPartie ? newPartie : defautPartie() )

    let newIndexes = {chapitre : indexes?.iChap, partie : indexes?.iPart, sequence : indexes?.iSeq?indexes.iSeq:0}

    //autosave
    saveAdminContent(newFormation, newIndexes)
  }

  const deletePartie = (indexes) => {
    let newFormation = JSON.parse(JSON.stringify(content))
    newFormation?.chapitre[indexes?.iChap]?.partie?.splice(indexes?.iPart, 1)

    newFormation = checkAllPositions(newFormation)

    //si il ne reste plus de partie, on doit en rajouter une
    if (newFormation?.chapitre[indexes?.iChap]?.partie?.length === 0) {
      newFormation?.chapitre[indexes?.iChap]?.partie?.splice(0, 0, defautPartie() )
      newFormation = checkAllPositions(newFormation)
    }

    setContent(newFormation)

    //on regarde pour les indexes
    if (adminPlayerIndexes?.chapitre === indexes?.iChap) {
      if (adminPlayerIndexes?.partie === indexes?.iPart) {
        var iPartNew = indexes?.iPart === 0 ? 0 : indexes?.iPart - 1
        setAdminPlayerIndexes({chapitre : adminPlayerIndexes?.chapitre, partie : iPartNew, sequence : 0})
      } else if (adminPlayerIndexes?.partie > indexes?.iPart) {
        setAdminPlayerIndexes({chapitre : adminPlayerIndexes?.chapitre, partie : adminPlayerIndexes?.partie - 1, sequence : adminPlayerIndexes?.sequence})
      }
    }

    //autosave
    saveAdminContent(newFormation)
  }

  const duplicatePartie = (indexes) => {
    var iChap = indexes?.iChap
    var iPart = indexes?.iPart

    var newPartie = JSON.parse(JSON.stringify(content?.chapitre[iChap]?.partie[iPart]))
    addPartie({ iChap: iChap, iPart: iPart + 1, iSeq: 0 }, newPartie)
  }

  const addSequence = (indexes, newSequence) => {
    let newFormation = JSON.parse(JSON.stringify(content))

    newFormation?.chapitre[indexes?.iChap]?.partie[indexes?.iPart]?.sequence?.splice(indexes?.iSeq, 0, newSequence)

    let newIndexes = {chapitre : indexes?.iChap, partie : indexes?.iPart, sequence : indexes?.iSeq}

    //autosave
    saveAdminContent(newFormation, newIndexes)
  }

  const deleteSequence = (indexes) => {
    let newFormation = JSON.parse(JSON.stringify(content))
    newFormation?.chapitre[indexes?.iChap]?.partie[indexes?.iPart]?.sequence?.splice(
      indexes?.iSeq,
      1
    )

    newFormation = checkAllPositions(newFormation)

    //si il ne reste plus de sequence, on doit en rajouter une
    if (newFormation?.chapitre[indexes?.iChap].partie[indexes?.iPart].sequence?.length === 0) {
      newFormation?.chapitre[indexes?.iChap]?.partie[indexes?.iPart]?.sequence?.splice(0, 0, listFormats("Titre"))
      newFormation = checkAllPositions(newFormation)
    }

    //on regarde pour les indexes
    if ((adminPlayerIndexes?.chapitre === indexes?.iChap) && (adminPlayerIndexes?.partie === indexes?.iPart)) {
      if (adminPlayerIndexes?.sequence == indexes?.iSeq) {
        var iSeqNew = indexes?.iSeq == 0 ? 0 : indexes?.iSeq - 1
        setAdminPlayerIndexes({chapitre : adminPlayerIndexes?.chapitre, partie : adminPlayerIndexes?.partie, sequence : iSeqNew})
      } else if (adminPlayerIndexes?.sequence > indexes?.iSeq) {
        setAdminPlayerIndexes({chapitre : adminPlayerIndexes?.chapitre, partie : adminPlayerIndexes?.partie, sequence : adminPlayerIndexes?.sequence - 1})
      }
    }

    //autosave
    saveAdminContent(newFormation)
  }

  const duplicateSequence = (indexes) => {
    var iChap = indexes?.iChap
    var iPart = indexes?.iPart
    var iSeq = indexes?.iSeq

    var newFormat = JSON.parse(JSON.stringify(content?.chapitre[iChap]?.partie[iPart]?.sequence[iSeq]))
    addSequence({ iChap: iChap, iPart: iPart, iSeq: iSeq+1 }, newFormat)
  }

  const onSequenceChange = (type, data, indexes) => {
    try {
      let newFormation = JSON.parse(JSON.stringify(content))
      newFormation.chapitre[indexes?.chapitre].partie[indexes?.partie].sequence[indexes?.sequence][type] = data

      setContent(newFormation)
      setPlayerHasChanged(true)
    } catch(e) {
      console.log(e)
    }
  }

  return (
    <SuperAdminContext.Provider
      value={{
        updateSuperAdminContext,
        groupes,
        setGroupes,
        updateAdminGroupes,
        contents,
        setContents,
        updateAdminContents,
        adminClients,
        updateAdminAdminClients,
        ecoles,
        updateAdminEcoles,
        overlayForSave,
        setOverlayForSave,
        saveAdminContent,
        playerHasChanged,
        setPlayerHasChanged,
        content,
        setContent,
        adminPlayerIndexes,
        setAdminPlayerIndexes,
        checkAllPositions,
        addChapitre,
        deleteChapitre,
        duplicateChapitre,
        addPartie,
        deletePartie,
        duplicatePartie,
        addSequence,
        deleteSequence,
        duplicateSequence,
        onSequenceChange,
      }}
    >
      {children}
    </SuperAdminContext.Provider>
  )
}

export default SuperAdminContext

export { SuperAdminProvider }
